<template>
  <div id="content"  class="valign-wrapper height-full">
            <div  class="row">
                <div class="col s12 z-depth-4 card">
                    <form id="frmLogin" @submit.prevent="onSubmit">
                        <div class="row login-panel">
                            <div class="input-field col s12 center">
                                <img src="../../assets/logo.png" alt="CombiLog System" class="responsive-img logo-login">
                                <h1 class="center ">Sistema Indicadores</h1>
                            </div>
                        </div>

                        <div class="row ">
                            <div class="input-field col s12 ">
                                <i class="material-icons prefix ">account_circle</i>
                                <input id="username" type="email" name="username" required v-model="email">
                                <label for="username" class="center-align">E-mail</label>
                            </div>
                        </div>
                        <div class="row ">
                            <div class="input-field col s12">
                                <i class="material-icons prefix">lock_outline</i>
                                <input id="password" name="password" type="password" required v-model="password">
                                <label for="password">Password</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <button type="submit" class="btn waves-effect waves-light col s12" >Entrar</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <button type="button" @click="recuperarPassword" class="btn-flat waves-effect waves-light col s12" >Recuperar password</button>
                            </div>
                        </div>
                            <div v-if="verifyingUser" class="progress">
                                <div class="indeterminate"></div>
                            </div>

                          <inncosys-card-message :clear-method="clearError" :msg="errores[errorMsg]" :success="false"></inncosys-card-message>
                    </form>
                </div>
            </div>
        </div>
</template>
<script>
import CardMessage from "../../components/commun/CardMessage.vue";
import { auth, db } from "../../main";

export default {
  mounted() {},
  data() {
    return {
      email: "",
      password: "",
      errores: {
        "auth/invalid-email": "Por favor ingresa un correo valido",
        "auth/user-disabled":
          "La autenticación por correo no esta habilitada en este proyecto",
        "auth/user-not-found": "Este usuario no existe",
        "auth/wrong-password":
          "Por favor verifica tu usuario y contraseña e intenta de nuevo",
        "auth/network-request-failed":
          "Por favor verifica tu conexión a internet",
        "auth/popup-closed-by-user": "Se ha cancelado la operación",
        "auth/user-cancelled": "Se ha cancelado la operación",
        recoverSuccess:
          "Hemos enviado instrucciones a tu correo electronico para recuperar tu contraseña "
      }
    };
  },
  methods: {
    onSubmit() {
      const formData = {
        email: this.email,
        password: this.password
      };
      this.$store.dispatch("signUserIn", formData); // we excecure the centralized method (action) located in sotore/modules/auth.js
    },
    clearError() {
      this.$store.commit("clearError"); // we excecure the centralized method (mutation) located in sotore/modules/auth.js
    },
    recuperarPassword() {
      const vue = this;
      if (this.email) {
        auth
          .sendPasswordResetEmail(this.email)
          .then(() => {
            M.toast({ html: "¡Correo enviado!" });
          })
          .catch(error => {
            M.toast({
              html: `Ocurrio un error: ${vue.$t(error.code)}`
            });
          });
      } else {
        M.toast({ html: "Write down your email please" });
      }
    }
  },
  computed: {
    errorMsg() {
      return this.$store.getters.errorMsgLogin;
    },
    user() {
      return this.$store.getters.user;
    },
    verifyingUser() {
      return this.$store.getters.verifyingUser;
    }
  },
  components: {
    inncosysCardMessage: CardMessage
  }
};
</script>
<style scoped>
#content {
  background-image: url(../../assets/background.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
.card {
  background-color: rgba(250, 250, 250, 0.9) !important;
}
.login-panel {
  min-width: 350px;
}
h1 {
  font-size: 1.15rem;
  line-height: 110%;
  margin: 0.7666666667rem 0 0.46rem 0;
}
</style>
